'use strict';

import {passwordInput} from '../models/password-input';
import {passwordValidation} from 'helpers/password-validation';
import {form} from '../models/form'

function createNewPasswordForm(createNewPasswordForm) {
  var contextualHelp = createNewPasswordForm.querySelector('small.password-validity-info');
  var validators = passwordValidation.createValidationsFrom(contextualHelp.querySelectorAll('span[data-pattern]'));
  var passwordInputElement = createNewPasswordForm.querySelector('.password-input');
  var passwordField = passwordInput.forCreate(passwordInputElement, validators, contextualHelp);

  form.create(createNewPasswordForm, [passwordField]);
}

function init() {
  var component = document.querySelector('.create-new-password-form');
  if(component) {
    createNewPasswordForm(component);
  }
}

if ('querySelector' in document) {
  init();
}
